export interface UserSettingViewModel {
    completedFirstStory: boolean,
    completedSchedule: boolean,
    completedInviteMember: boolean
}

export class UserSettingViewModel {
    constructor() { }
}